// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";
import { useScript } from "@mcmc/App/Widgets/ExternalScriptWidget/useScript";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: McMcApplicationState) => {
    const customSettings = getSettingsCollection(state).customSettings;
    const scriptSrc = customSettings.marketoFormScriptSrc;
    const marketoHostName = customSettings.marketoHostName;
    const scriptHost = scriptSrc ? `//${scriptSrc.split("/")[2]}` : "";
    const marketoSubDomain = marketoHostName ? `${marketoHostName.split(".")[0]}` : "";
    return {
        scriptSrc,
        scriptHost,
        marketoSubDomain,
    };
};
export interface MarketoFormStyles {
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
}
export const marketoFormStyles: MarketoFormStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    loadingSpinner: {
        css: css`
            margin: auto;
        `,
    },
};
const styles = marketoFormStyles;
interface OwnProps {
    formId?: string;
    onLoad?: (marketoForm?: any) => void;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps>;
const MarketoForm: React.FC<Props> = ({ scriptSrc, scriptHost, marketoSubDomain, formId, onLoad }) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const scriptStatus = useScript(scriptSrc);
    React.useEffect(() => {
        if (!scriptSrc || !scriptHost || !marketoSubDomain) {
            setIsLoading(false);
            return;
        }
        if (scriptStatus === "ready") {
            const { MktoForms2 } = window as any;
            MktoForms2.loadForm(scriptHost, marketoSubDomain, formId, (marketoForm: any) => {
                setIsLoading(false);
                const marketoFormElement = marketoForm.render()[0];
                marketoFormElement.id = "";
                const formWrapper = document.getElementById(`mktoForm_${formId}_wrapper`);
                if (formWrapper) {
                    formWrapper.innerHTML = "";
                    formWrapper.appendChild(marketoFormElement);
                }
                onLoad && onLoad(marketoForm);
            });
        }
    }, [scriptStatus]);
    if (!scriptSrc || !scriptHost || !marketoSubDomain) {
        return null;
    }
    return (
        <>
            {isLoading && (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.loadingSpinner}></LoadingSpinner>
                </StyledWrapper>
            )}
            <StyledWrapper id={`mktoForm_${formId}_wrapper`}></StyledWrapper>
        </>
    );
};
export default connect(mapStateToProps)(MarketoForm);
